<template>
  <div class="d-flex">
    <Checkbox
      class="rapq_checkbox mr-2"
      :value="value"
      style="--clr-label: var(--clr-white-0)"
      @input="handleInput"
    >
      {{ title }}
    </Checkbox>
    <div
      class="csst mdi mdi-help-circle-outline clr-grey text-medium"
      @mouseenter="fl_positionTooltip"
    >
      <div
        v-if="tooltip"
        class="csst_content f-column pb-1 clr-white"
        style="position: fixed"
      >
        {{ tooltip }}
      </div>
    </div>
  </div>
</template>
<script>
import Checkbox from '@/components/Common/Checkbox/Checkbox'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'SettingsCheckbox',
  components: {
    Checkbox,
  },
  mixins: [float_mix],
  props: {
    settingsKey: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: true,
    },
    customSet: {
      type: Function,
      default: null,
    },
    customGet: {
      type: Function,
      default: null,
    },
  },
  methods: {
    handleInput(value) {
      if (this.customSet) {
        this.customSet(value)
        return
      }
      this.$store.dispatch('userSettings', { [this.settingsKey]: value })
    },
  },
  computed: {
    mergedUserSettings() {
      return this.$store.getters.mergedUserSettings
    },
    value() {
      if (this.customGet) return this.customGet()
      return !!this.mergedUserSettings[this.settingsKey]
    },
  },
}
</script>
